import { BillingCards } from 'components/BillingCards'
import { DoublePanelViewLayout } from 'layouts'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import '@splidejs/react-splide/dist/css/splide-core.min.css'
import useQueryParams from 'utils/hooks/useQueryParams'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import styles from 'modules/Billing/Billing.module.scss'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'

export default function Billing({ children }) {
  const { t } = useTranslation(['billing'])
  const { query } = useQueryParams()
  const [billingConfig] = useLocalStorage('billing', {})
  const history = useHistory()
  const location = useLocation()
  const pathGen = useGeneratePathI18n()
  const {
    data: { methods: { data: methods = [] } = {}, activeMethod },
    resetData,
    setActiveMethod,
  } = useBilling()

  useEffect(() => () => resetData(), [])

  const methodIndex = useCallback(
    (methodName) => methods.findIndex(({ method }) => method === methodName),
    [methods],
  )

  useEffect(() => {
    if (methods && methods.length) {
      let activeIndex = 0
      if (query.method && methodIndex(query.method) > -1) {
        activeIndex = methodIndex(query.method)
      } else if (billingConfig.method && methodIndex(billingConfig.method) > -1) {
        activeIndex = methodIndex(billingConfig.method)
      }
      setActiveMethod(methods[activeIndex].method)
    }
  }, [methods])

  const handleClose = () => {
    if (location.key && history.length > 1) {
      history.goBack()
    } else {
      history.push(pathGen(ROUTES.SERVICES))
    }
  }

  return (
    <DoublePanelViewLayout
      onClose={handleClose}
      side={
        <BillingCards
          cards={methods.map(({ method, ...rest }) => ({
            id: method,
            title: t(`methods.${method}`).replace('methods.', ''),
            name: method,
            active: activeMethod?.method === method,
            ...rest,
          }))}
        />
      }
    >
      <div className={clsx(formStyles['formContainer__inner'], styles['billing'])}>
        <div className={styles['billing__content']}>
          <div className={styles['billing__content-inner']}>
            {React.cloneElement(children, { onClose: handleClose })}
          </div>
        </div>
      </div>
    </DoublePanelViewLayout>
  )
}

Billing.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
    PropTypes.oneOf([null]),
  ]),
}
